import type { FunctionComponent } from 'react';

import { Table } from '@kanda-libs/ks-component-ts';

import usePartnerTableProps from './usePartnerTableProps';

const PartnerTable: FunctionComponent = function () {
  const tableProps = usePartnerTableProps();

  return (
    <>
      <Table {...tableProps} />
    </>
  );
};

export default PartnerTable;
